import DraftModule from "./DraftModule";
import reducer from "./redux/draftReducer";
import rootSaga from "./redux/draftSagas";

export default {
  Component: DraftModule,
  moduleName: "draft",
  saga: rootSaga(),
  reducer: reducer
};
